import { Spin } from "antd";
import { Suspense, lazy, useEffect } from "react";
import "react-loading-skeleton/dist/skeleton.css";
import { useDispatch, useSelector } from "react-redux";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "tippy.js/dist/tippy.css";
import "./App.css";
import SuperAdminRoutes from "./apps/super-admin/routes/Routes";
import UserRoutes from "./apps/user/routes/Routes";
import HorizontalLayout from "./components/layouts/HorizontalLayout";
import {
  getActiveAppToLocalStorage,
  getTokenFromLocalStorage,
} from "./helpers/helpers";
import { initialize, setActiveApp } from "./redux/actions/app";
import {
  checkViewAccess,
  getActiveApp,
  getActiveView,
  getCurrentUserInfo,
  getUserRole,
  isAppInitializing,
} from "./redux/selectors/app";

const ForgotPassword = lazy(() =>
  import("./tabs/auth/forgot-password/ForgotPassword")
);
const ResetPassword = lazy(() =>
  import("./tabs/auth/reset-password/ResetPassword")
);
const Login = lazy(() => import("./tabs/auth/Login"));
const Register = lazy(() => import("./tabs/auth/register/Register"));
const Dashboard = lazy(() => import("./tabs/dashboard/Dashboard"));
const Saloons = lazy(() => import("./tabs/saloons/Saloons"));
const SaloonsCreate = lazy(() => import("./tabs/saloons/create/Create"));

function App() {
  const location = useLocation();

  const dispatch = useDispatch();

  const isViewAllowed = useSelector(checkViewAccess);
  const activeView = useSelector(getActiveView);
  const activeApp = useSelector(getActiveApp);

  const isLoggedIn = !!getTokenFromLocalStorage();

  const userInfo = useSelector(getCurrentUserInfo);
  const userRole = userInfo?.role ?? 3;

  const isInitializing = useSelector(isAppInitializing);

  useEffect(() => {
    if (isLoggedIn) {
      dispatch(initialize());
    }
  }, [dispatch, isLoggedIn]);

  useEffect(() => {
    // if (getActiveAppToLocalStorage() && !activeApp) {
    //   console.log("line 61 ", getActiveAppToLocalStorage());
    //   if (
    //     location.pathname.includes("/vendor") &&
    //     !location.pathname.includes("/store")
    //   ) {
    //     dispatch(setActiveApp(ACTIVE_APP.VENDOR));
    //     return;
    //   }
    //   if (
    //     location.pathname.includes("/vendor") &&
    //     location.pathname.includes("/store")
    //   ) {
    //     dispatch(setActiveApp(ACTIVE_APP.STORE));
    //     dispatch(setActiveView(ACTIVE_VIEW.VENDOR));
    //     return;
    //   }

    //   if (
    //     !location.pathname.includes("vendor") &&
    //     activeView === ACTIVE_VIEW.VENDOR
    //   ) {
    //     dispatch(setActiveApp(ACTIVE_APP.STORE));
    //     dispatch(setActiveView(ACTIVE_VIEW.STANDARD));
    //   }

    //   if (
    //     !location.pathname.includes("/vendor") &&
    //     location.pathname.includes("/store")
    //   ) {
    //     dispatch(setActiveApp(ACTIVE_APP.STORE));
    //     dispatch(setActiveView(ACTIVE_VIEW.STANDARD));
    //   }
    // }
    if (!getActiveAppToLocalStorage()) {
      dispatch(setActiveApp(""));
    }
  }, [activeView, dispatch, location.pathname]);

  if (isInitializing) {
    return (
      <div className="flex justify-center items-center h-full">
        <Spin size="large" />
      </div>
    );
  }

  // if (userRole === 1) {
  //   return <SuperAdminRoutes />;
  // }
  return (
    <>
      <ToastContainer />
      <Suspense
        fallback={
          <div className="flex justify-center items-center h-full">
            <Spin size="large" />
          </div>
        }
      >
        {getRoutes(userRole)}
      </Suspense>
    </>
  );
}

export default App;

export const AuthRoute = ({ isInLayout = true }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userRole = useSelector(getUserRole);
  const activeApp = useSelector(getActiveApp);

  useEffect(() => {
    if (!getTokenFromLocalStorage()) {
      navigate("/login");
      return;
    }
    // else {
    //   if (!activeApp) {
    //     navigate("/select-app");
    //   }
    // }
  }, [navigate]);

  if (!isInLayout) {
    return <Outlet />;
  }

  return (
    <HorizontalLayout>
      <Outlet />
    </HorizontalLayout>
  );
};

function getRoutes(role) {
  if (role === 1) {
    return <SuperAdminRoutes />;
  }
  return <UserRoutes />;
}
